import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useAssignee, useOwners, useReviewers } from "PFApp/hooks/activity_commons/participants";
import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { AddActivityProfilesModal } from "./add_activity_profiles_modal";

type AddActivityProfilesButtonProps = {
  small?: boolean;
};

export const AddActivityProfilesButton = ({ small }: AddActivityProfilesButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation("activities");
  const activity = useCurrentActivity();

  const { canWrite: canWriteOwners } = useOwners(activity);
  const { canWrite: canWriteAssignee } = useAssignee(activity);
  const { canWrite: canWriteReviewers } = useReviewers(activity);

  const canAddProfiles = canWriteOwners || canWriteReviewers || canWriteAssignee;

  if (!canAddProfiles) {
    return null;
  }

  return (
    <>
      <Tooltip content={<Typography variant="bodyRegular">{t("show.addProfiles.title_other")}</Typography>}>
        <Button
          icon="owner"
          kind="secondary"
          aria-label={t("show.addProfiles.title_other")}
          onClick={() => setIsModalOpen(true)}
          small={small}
        />
      </Tooltip>
      {isModalOpen && <AddActivityProfilesModal onClose={() => setIsModalOpen(false)} activity={activity} />}
    </>
  );
};
